exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item .icon{\r\n    margin-right: unset;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/type/type.css
// module id = ../../../../../src/app/pages/admin/icontact/setting/type/type.css
// module chunks = main